import React, { Component } from 'react'
import './Contribute.css'
import $ from "jquery"

class Contribute extends Component {

  closeContribute(e) {
    e.preventDefault()
    $('#contribute').fadeOut()
  }

  getCsrfToken(callback) {
    var deferred = $.Deferred()
      $.get('https://api.culturecompass.org/rest/session/token')
      .done(function(data) {
        var csrfToken = data;
        deferred.resolve(csrfToken);
      });
      return deferred.promise();
  }

  submitPost(e) {
    e.preventDefault()
    $('.messages').empty()
    var _self = this;
    var email = $('#suggestion-email').val()
    var comment = $('#suggestion-comment').val()
    var category = $('#suggestion-category').val()
    if (email && comment) {
     $('.loader').fadeIn();
     $('#contribute').fadeOut()
    _self.getCsrfToken().then(function(csrfToken) {
      var data = {
        "type":[{"target_id":"suggestion"}],
        "title": [{ "value": "Suggestion from: " + email + " (" + category + ")"}],
        "field_suggestion_category": [{"value": category}],
        "field_email": [{"value": email}],
        "body": [{ "value": comment }]
      };
      console.log(JSON.stringify(data));
      console.log(csrfToken);
       var settings = {
       "async": true,
       "crossDomain": true,
       "url": "https://api.culturecompass.org/node?_format=json",
       "method": "POST",
       "headers": {
         "content-type": "application/json",
         "accept": "application/json",
         "authorization": "Basic Y29tbWVudHM6SFRjR3g2NlBUNWI=",
         "X-CSRF-Token": csrfToken
       },
       "data": JSON.stringify(data)
       }
       $.ajax(settings).done(function (response) {
         $('.loader').fadeOut();
         $('#suggestion-email').val('')
         $('#suggestion-comment').val('')
       });
     });
   } else {
     $('.messages').html('Please complete all fields')
   }
  }

  render() {
    return (
      <div>
        <div id="contribute">
         <a className="close" href="#close" onClick={(e) => this.closeContribute(e)}>x</a>
         <h1>Make a suggestion</h1>
         <div className="messages"></div>
         <form className="contribute-form">
         <div className="form-element">
           <label>Email</label>
           <input type="text" id="suggestion-email" placeholder="myemail@mydomain.com"/>
         </div>
         <div className="form-element">
         <label>Suggestion category</label>
         <select id="suggestion-category">
            <option value="arts-missing">Arts Organizations (Missing)</option>
            <option value="arts-inaccurate">Arts Organizations (Inaccurate)</option>
            <option value="arts-inaccurate">Arts Organizations (Miscellaneous)</option>
            <option value="transit">Transit</option>
            <option value="demographics">Demographics</option>
            <option value="land">Land Use</option>
            <option value="misc">Miscellaneous</option>
          </select>
          </div>
         <div className="form-element">
           <label>Comments</label>
           <textarea id="suggestion-comment" />
         </div>
         <a href="#submit" className="btn" onClick={(e) => this.submitPost(e)}>Submit</a>
         </form>
        </div>
      </div>
    );
  }
}

export default Contribute;



// WEBPACK FOOTER //
// ./src/components/Contribute/Contribute.js